<template>
  <div class="dropdown-parent-container">
    <button
      type="button"
      title="Visible Columns"
      class="sc3-button sc3-button-inline sc3-button-white-and-light-grey"
      :class="{ 'sc3-button-active': isOpen }"
      ref="columnVisibilityDropdownMenuButton"
      @click="toggleDropdown()"
    >
      Columns
    </button>
    <DropdownMenu
      :nodes-excluded-from-closing-on-outside-click="columnVisibilityDropdownMenuButton ? [columnVisibilityDropdownMenuButton] : []"
      :dropdown-button-left-value="left"
      v-model:is-open="isOpen"
      v-model:max-body-height="dropdownHeight"
      :dropdown-menu-toggle-button-node="columnVisibilityDropdownMenuButton"
    >
      <template v-slot:header>
        <div class="dropdown-header-container">
          <span class="dropdown-menu-title">VISIBLE COLUMNS</span>
        </div>
      </template>
      <template v-slot:body>
        <ul>
          <template
            v-for="column in COLUMNS"
            :key="column.title"
          >
            <li>
              <button
                type="button"
                class="ellipsis-overflow visibility-button"
                @click="[toggleColumnVisibility(column.value)]"
              >
                <i
                  :class="{
                    'fas fa-check-circle': shownColumns[column.value],
                    'far fa-circle': !shownColumns[column.value]
                  }"
                ></i>
                {{ column.title }}
              </button>
            </li>
          </template>
        </ul>
      </template>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { useBoundingClientRect } from '@/composables/useBoundingClientRect';
  import DropdownMenu from '@/components/dropdowns/DropdownMenu.vue';
  import { useChartListSummary } from '@/composables/useChartListSummary';

  const { COLUMNS, toggleColumnVisibility, shownColumns } = useChartListSummary();
  const { getBoundingClientRectPropertyRefs } = useBoundingClientRect();
  const columnVisibilityDropdownMenuButton = ref<HTMLButtonElement>();
  const isOpen = ref<boolean>(false);
  const dropdownHeight = ref<number>(0);
  const { left } = getBoundingClientRectPropertyRefs(columnVisibilityDropdownMenuButton, { windowResize: true });

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  watch(isOpen, () => {
    if (!isOpen.value) {
      columnVisibilityDropdownMenuButton.value?.blur();
    }
  });
</script>

<style scoped>
  .dropdown-parent-container {
    position: relative;
  }

  .dropdown-header-container {
    display: flex;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 900;
    color: #707f8f;
    text-align: left;
    padding: 2px 10px;
    margin: 0px;
  }

  ul {
    max-height: v-bind('`${dropdownHeight}px`');
  }

  .visibility-button {
    padding-top: 4px;
    padding-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .visibility-button i {
    font-size: 12px;
  }
</style>
